/**
 * Espelho best-effort dos slugs reservados pelo backend.
 */
export const RESERVED_SLUGS: ReadonlySet<string> = new Set([
  // infraestrutura existente
  "www", "app", "api", "hom", "admin", "mail", "portal", "status", "docs", "suporte",
  // plano de controle
  "backoffice", "console", "ops", "painel", "sistema",
  // reservas defensivas
  "auth", "id", "login", "billing", "cdn", "assets", "static", "dev", "stg", "test",
]);

export function isReservedSlug(value: string): boolean {
  return RESERVED_SLUGS.has(String(value ?? "").trim().toLowerCase());
}
